import { validatedJsonPostHelper } from '@loop/itops-fetch-wrapper-dom';
import { DlqIgnoreRules } from 'commbot-shared-types';
const endpoint = '/support/ringmaster';
const validateNullResponse = (thing) => {
    if (typeof thing === 'object' && thing.response === null) {
        return thing;
    }
    throw new Error(`Invalid response (expecting null): ${JSON.stringify(thing, null, 2)}`);
};
const validateIgnoreRules = (thing) => {
    if (typeof thing === 'object' && typeof thing.response === 'object') {
        if (thing.response.filter(DlqIgnoreRules.isDlqIgnoreRuleRecord).length === thing.response.length) {
            return thing;
        }
    }
    throw new Error(`Invalid response (expecting list of ignore rules): ${JSON.stringify(thing, null, 2)}`);
};
export const ringmasterProcessorResponseValidators = {
    DLQ_LIST_IGNORE_RULES: validateIgnoreRules,
    DLQ_LIST_TRASH_RULES: validateIgnoreRules,
    DLQ_UPSERT_IGNORE_RULE: validateNullResponse,
    DLQ_DELETE_IGNORE_RULE: validateNullResponse,
    DLQ_UPSERT_TRASH_RULE: validateNullResponse,
    DLQ_DELETE_TRASH_RULE: validateNullResponse,
};
const validatedJsonPostHelpers = {
    DLQ_LIST_IGNORE_RULES: (accessToken) => (args) => validatedJsonPostHelper(endpoint, {
        accessToken,
        data: {
            args,
            command: 'DLQ_LIST_IGNORE_RULES',
        },
        validate: ringmasterProcessorResponseValidators.DLQ_LIST_IGNORE_RULES,
    }),
    DLQ_DELETE_IGNORE_RULE: (accessToken) => (args) => validatedJsonPostHelper(endpoint, {
        accessToken,
        data: {
            args,
            command: 'DLQ_DELETE_IGNORE_RULE',
        },
        validate: ringmasterProcessorResponseValidators.DLQ_DELETE_IGNORE_RULE,
    }),
    DLQ_UPSERT_IGNORE_RULE: (accessToken) => (args) => validatedJsonPostHelper(endpoint, {
        accessToken,
        data: {
            args,
            command: 'DLQ_UPSERT_IGNORE_RULE',
        },
        validate: ringmasterProcessorResponseValidators.DLQ_UPSERT_IGNORE_RULE,
    }),
    DLQ_LIST_TRASH_RULES: (accessToken) => (args) => validatedJsonPostHelper(endpoint, {
        accessToken,
        data: {
            args,
            command: 'DLQ_LIST_TRASH_RULES',
        },
        validate: ringmasterProcessorResponseValidators.DLQ_LIST_TRASH_RULES,
    }),
    DLQ_DELETE_TRASH_RULE: (accessToken) => (args) => validatedJsonPostHelper(endpoint, {
        accessToken,
        data: {
            args,
            command: 'DLQ_DELETE_TRASH_RULE',
        },
        validate: ringmasterProcessorResponseValidators.DLQ_DELETE_TRASH_RULE,
    }),
    DLQ_UPSERT_TRASH_RULE: (accessToken) => (args) => validatedJsonPostHelper(endpoint, {
        accessToken,
        data: {
            args,
            command: 'DLQ_UPSERT_TRASH_RULE',
        },
        validate: ringmasterProcessorResponseValidators.DLQ_UPSERT_TRASH_RULE,
    }),
};
export const validatedJsonPostHelpersFactory = (accessToken, rulesType) => ({
    load: validatedJsonPostHelpers[rulesType === 'IGNORE' ? 'DLQ_LIST_IGNORE_RULES' : 'DLQ_LIST_TRASH_RULES'](accessToken),
    upsert: validatedJsonPostHelpers[rulesType === 'IGNORE' ? 'DLQ_UPSERT_IGNORE_RULE' : 'DLQ_UPSERT_TRASH_RULE'](accessToken),
    delete: validatedJsonPostHelpers[rulesType === 'IGNORE' ? 'DLQ_DELETE_IGNORE_RULE' : 'DLQ_DELETE_TRASH_RULE'](accessToken),
});
//# sourceMappingURL=api.js.map